import {
  Box,
  Container,
  Grid,
  TextField,
  Button,
  AppBar,
  Toolbar,
  Typography,
  Card,
  CardContent,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import "./App.css";
import { useEffect, useState } from "react";
import { createContact } from "./service";
import default_logo from "./assets/images/app_logo.svg";
import LanguageSwitcher from "./LanguageSwitcher";
import { lang_options } from "./language";
function App() {
  const [lang, setLanguage] = useState("de");
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState("success");
  const [message, setMessage] = useState("");
  const anchor = { vertical: "top", horizontal: "right" };
  const [isSubmiting, setSubmitting] = useState(false);
  const [values, setValues] = useState({
    company_name: null,
    no_of_trucks: null,
    no_of_trailers: null,
    avg_mileage_per_year: null,
    avg_fuel_per_100_km: null,
    price_per_liter_diesel: 1.5,
    first_name: null,
    last_name: null,
    email: null,
    phone_no: null,
  });
  const [fuelCosts, setFuelCosts] = useState(null);
  const [co2Emissions, setCo2Emissions] = useState(null);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    calc_estimate();
    // eslint-disable-next-line
  }, [values]);
  const handleClose = () => {
    setOpen(false);
    setStatus("success");
    setMessage("");
  };
  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await createContact(values);
      if (res?.status === 200) {
        setMessage(res?.data?.return_message);
        setStatus("success");
        setOpen(true);
      } else if (res?.status === 201) {
        setMessage(res?.data?.return_message);
        setStatus("success");
        setOpen(true);
      } else {
        setMessage("An error occured , plz try again");
        setStatus("error");
        setOpen(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };
  const calc_estimate = () => {
    let units = values.no_of_trucks;

    let km = values.avg_mileage_per_year / 100;

    if (units && km && values.avg_fuel_per_100_km) {
      const avg_fuel_consumption = values.avg_fuel_per_100_km;

      const fuel_cost = values.price_per_liter_diesel;
      const co2_per_km = 2.64;

      const total_liters_burnt = units * km * avg_fuel_consumption;

      const max_fuel_savings_potential = total_liters_burnt * fuel_cost * 0.04;
      const max_co2_savings_potential = total_liters_burnt * co2_per_km * 0.04;
      setFuelCosts(
        Number(max_fuel_savings_potential).toLocaleString("es-ES", {
          maximumFractionDigits: 2,
        })
      );

      setCo2Emissions((max_co2_savings_potential / 1000).toFixed(2));
    }
  };
  return (
    <div className="App">
      <AppBar position="static" color="default">
        <Toolbar>
          <Box sx={{ display: "flex", flexDirection: "row", flexGrow: 1 }}>
            <Box sx={{ marginRight: "1rem" }}>
              <img
                src={default_logo}
                style={{ objectFit: "contain" }}
                alt="logo"
              />
            </Box>
            <Typography variant="h6" color={"primary"} gutterBottom>
              Savings
            </Typography>
          </Box>
          {lang !== null && (
            <LanguageSwitcher lang={lang} setLanguage={setLanguage} />
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box
          sx={{
            maxWidth: "100%",
            minHeight: "93vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card sx={{ opacity: "0.93", margin: "1rem 0rem" }}>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item lg={6} xs={12}>
                    <TextField
                      fullWidth
                      name="no_of_trucks"
                      type="number"
                      onChange={(e) => handleChange(e)}
                      id="outlined-basic"
                      label={lang_options[lang]["no_of_trucks"]}
                      variant="outlined"
                      value={values.no_of_trucks}
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <TextField
                      name="no_of_trailers"
                      fullWidth
                      type="number"
                      onChange={(e) => handleChange(e)}
                      id="outlined-basic"
                      label={lang_options[lang]["no_of_trailers"]}
                      variant="outlined"
                      value={values.no_of_trailers}
                    />
                  </Grid>
                  <Grid item lg={12} xs={12}>
                    <TextField
                      name="avg_mileage_per_year"
                      fullWidth
                      type="number"
                      onChange={(e) => handleChange(e)}
                      id="outlined-basic"
                      label={lang_options[lang]["avg_mileage_per_year"]}
                      variant="outlined"
                      value={values.avg_mileage_per_year}
                    />
                  </Grid>

                  <Grid item lg={6} xs={12}>
                    <TextField
                      fullWidth
                      name="avg_fuel_per_100_km"
                      type="number"
                      onChange={(e) => handleChange(e)}
                      id="outlined-basic"
                      label={lang_options[lang]["avg_fuel_per_100_km"]}
                      variant="outlined"
                      value={values.avg_fuel_per_100_km}
                    />
                  </Grid>
                  <Grid item lg={6} xs={12}>
                    <TextField
                      name="price_per_liter_diesel"
                      fullWidth
                      type="number"
                      onChange={(e) => handleChange(e)}
                      id="outlined-basic"
                      label={lang_options[lang]["price_per_liter_diesel"]}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={values.price_per_liter_diesel}
                    />
                  </Grid>
                  <Grid item lg={12}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      align="center"
                      color="primary"
                    >
                      {lang_options[lang]["savings_potentials"]}
                    </Typography>
                  </Grid>
                  <Grid item lg={6} xs={6}>
                    <Typography variant="h6" gutterBottom align="center">
                      {lang_options[lang]["fuel_costs"]}
                    </Typography>
                  </Grid>
                  <Grid item lg={6} xs={6}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      align="center"
                      color="primary"
                      fontWeight={"bold"}
                    >
                      {fuelCosts ? (
                        <>
                          {fuelCosts} {"€"}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </Typography>
                  </Grid>
                  <Grid item lg={6} xs={6}>
                    <Typography variant="h6" gutterBottom align="center">
                      {lang_options[lang]["co2_emissions"]}
                    </Typography>
                  </Grid>
                  <Grid item lg={6} xs={6}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      align="center"
                      fontWeight={"bold"}
                      color="primary"
                    >
                      {co2Emissions ? (
                        <>
                          {co2Emissions} {"Tonnes"}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </Typography>
                  </Grid>
                  <Grid item lg={12}>
                    <Button
                      variant="text"
                      style={{ textTransform: "unset" }}
                      onClick={() => setToggle(!toggle)}
                    >
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        fontWeight={"bold"}
                      >
                        {lang_options[lang]["learn_more"]}
                      </Typography>
                    </Button>
                  </Grid>
                  {toggle && (
                    <>
                      <Grid item lg={12} xs={12} sm={12}>
                        <TextField
                          fullWidth
                          required
                          name="company_name"
                          onChange={(e) => handleChange(e)}
                          id="outlined-basic"
                          label={lang_options[lang]["company_name"]}
                          variant="outlined"
                          value={values.company_name}
                        />
                      </Grid>
                      <Grid item lg={6} xs={12} sm={12}>
                        <TextField
                          fullWidth
                          name="first_name"
                          onChange={(e) => handleChange(e)}
                          id="outlined-basic"
                          label={lang_options[lang]["first_name"]}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item lg={6} xs={12} sm={12}>
                        <TextField
                          name="last_name"
                          fullWidth
                          onChange={(e) => handleChange(e)}
                          id="outlined-basic"
                          label={lang_options[lang]["last_name"]}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item lg={6} xs={12} sm={12}>
                        <TextField
                          fullWidth
                          name="email"
                          onChange={(e) => handleChange(e)}
                          id="outlined-basic"
                          label={lang_options[lang]["email"]}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item lg={6} xs={12} sm={12}>
                        <TextField
                          name="phone_no"
                          fullWidth
                          onChange={(e) => handleChange(e)}
                          id="outlined-basic"
                          label={lang_options[lang]["phone_no"]}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item lg={12} xs={12} sm={12}>
                        <Button
                          fullWidth
                          disabled={isSubmiting}
                          type="submit"
                          variant="contained"
                          style={{ textTransform: "unset" }}
                        >
                          {isSubmiting ? (
                            <CircularProgress />
                          ) : (
                            <> {lang_options[lang]["submit"]}</>
                          )}
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Container>
      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={anchor}
      >
        <Alert severity={status} variant="filled" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default App;
